import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from '../../config/app.config';
import { AppSettingsService } from '../../services/app-settings/app-settings.service';

@Pipe({
  name: 'appCurrency'
})
export class AppCurrencyPipe implements PipeTransform {
  // currencyCode = AppConfig.baseCurrency;
  constructor(
    private currencyPipe: CurrencyPipe,
    private setting: AppSettingsService
  ) {

  }
  transform(value: any, symbol?: boolean): any {
    debugger;
    // console.log(this.currencyCode);
    if (!value) {
      return '';
    }
    if(symbol){
      return value + " ("+ this.setting.environment.currency.symbol +")";
    }
    const xValue = this.currencyPipe.transform(value, this.setting.environment.currency.symbol);
    let fValue = xValue.replace(this.setting.environment.currency.replace, '');
    return fValue;
  }
}
